import $ from 'jquery';
import {showFormResponse} from '../common/json-response';

const formStatusMessages = document.querySelector('.action-status-messages');
const fieldsStatusMessages = document.querySelectorAll('.field-action-status-messages');

let form;
let fieldsData = {custom_fields: {}};

function getContestInfoSettingsFields() {
  // убираем предыдущие сообщения
  formStatusMessages.innerHTML = '';
  fieldsStatusMessages.forEach((field) => {
    field.innerHTML = '';
  });

  const title = form.querySelector('[name="title"]');
  const regions = form.querySelectorAll('[name="contest_categories_region[]"]:checked');
  const auditories = form.querySelectorAll('[name="contest_categories_auditory[]"]:checked');
  const themes = form.querySelectorAll('[name="contest_categories_theme[]"]:checked');
  const fee_type = form.querySelector('[name="fee_type"]');
  const fee_conditions = form.querySelector('[name="fee_conditions"]');
  const send_certificate = form.querySelector('[name="send_certificate"]');
  const send_certificate_types = form.querySelectorAll('[name="send_certificate_types[]"]:checked');
  const certificate_info = form.querySelector('[name="certificate_info"]');
  const content = form.querySelector('[name="content"]');
  const goals = form.querySelector('[name="goals"]');
  const tasks = form.querySelector('[name="tasks"]');
  const prizes = form.querySelector('[name="prizes"]');
  const organization = form.querySelector('[name="organization"]');
  const phone = form.querySelector('[name="phone"]');
  const contest_email = form.querySelector('[name="contest_email"]');
  const extra_contact_type = form.querySelector('[name="extra_contact[type]"]');
  const extra_contact_value = form.querySelector('[name="extra_contact[value]"]');
  const min_works = form.querySelector('[name="min_works"]');
  const terms_id_ajax = form.querySelector('[name="terms_id_ajax"]');
  const terms_id = form.querySelector('[name="terms_id"]');
  const documents = form.querySelectorAll('[name="documents[]"]');

  fieldsData = {
    ...fieldsData,
    title: null,
    fee_type: null,
    fee_conditions: null,
    send_certificate: null,
    certificate_info: null,
    content:   null,
    goals: null,
    tasks: null,
    prizes: null,
    organization: null,
    phone: null,
    contest_email: null,
    min_works: null,
    terms_id_ajax: null,
    terms_id: null,
    document: null,
  }

  fieldsData['extra_contact[type]'] = null;
  fieldsData['extra_contact[value]'] = null;
  fieldsData['contest_categories_region[]'] = [];
  fieldsData['contest_categories_auditory[]'] = [];
  fieldsData['contest_categories_theme[]'] = [];
  fieldsData['send_certificate_types[]'] = [];
  fieldsData['documents[]'] = [];

  fieldsData['title'] = title?.value;
  fieldsData['fee_type'] = fee_type?.value;
  fieldsData['fee_conditions'] = fee_conditions?.value;
  fieldsData['send_certificate'] = send_certificate?.value;
  fieldsData['certificate_info'] = certificate_info?.value;
  fieldsData['content'] = content?.value;
  fieldsData['goals'] = goals?.value;
  fieldsData['tasks'] = tasks?.value;
  fieldsData['prizes'] = prizes?.value;
  fieldsData['organization'] = organization?.value;
  fieldsData['phone'] = phone?.value;
  fieldsData['contest_email'] = contest_email?.value;
  fieldsData['extra_contact[type]'] = extra_contact_type?.value;
  fieldsData['extra_contact[value]'] = extra_contact_value?.value;
  fieldsData['min_works'] = min_works?.value;
  fieldsData['terms_id_ajax'] = terms_id_ajax?.value;
  fieldsData['terms_id'] = terms_id?.value;
  fieldsData['documents'] = document?.value;

  regions.forEach(input => {
    fieldsData['contest_categories_region[]'].push(input.value);
  });

  auditories.forEach(input => {
    fieldsData['contest_categories_auditory[]'].push(input.value);
  });

  themes.forEach(input => {
    fieldsData['contest_categories_theme[]'].push(input.value);
  });

  send_certificate_types.forEach(input => {
    fieldsData['send_certificate_types[]'].push(input.value);
  });

  documents.forEach(input => {
    fieldsData['documents[]'].push(input.value);
  });

  return fieldsData;
}

function getSendUrl() {
  let url = saveBtn.getAttribute('data-url');

  return url;
}

function initContestInfoSettings() {
  const saveBtn = document.querySelector('#saveBtn[name="contest-info-settings-save"]');
  form = document.querySelector('.contest-info-settings');

  if (!saveBtn || !form) {
    return;
  }

  saveBtn?.addEventListener('click', function (e) {
    e.preventDefault();

    fieldsData = getContestInfoSettingsFields();
    const url = getSendUrl();

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: fieldsData,
      success: function (data) {
        if (data.redirectTo?.length) {
          window.location.href = data.redirectTo;
        }

        showFormResponse(data);
      },
      error: function (data) {
        showFormResponse(data);
      },
    });
  });
}

export { getContestInfoSettingsFields, initContestInfoSettings }
